import React from 'react';

import img1 from '../assests/img/partner-01.png';
import img2 from '../assests/img/partner-02.png';
import img3 from '../assests/img/partner-03.png';
import img4 from '../assests/img/partner-04.png';
import img5 from '../assests/img/partner-05.png';
import img6 from '../assests/img/partner-06.png';
import img7 from '../assests/img/partner-07.png';
import img8 from '../assests/img/partner-08.png';
import img9 from '../assests/img/partner-09.png';
import img10 from '../assests/img/partner-10.png';





function Supportedasso() {
  return (
    <>     
      <section className="show-activity partner-sec">

        <div className='sec-title'>
          <h2>Supported Association</h2>
          <div class="separator"></div>
        </div>

        <div className="container-fluid">
          <div className="row-inner">
            <div className='gallery-box'>
              <img src={img1}/>
            </div>
            <div className='gallery-box'>
              <img src={img2}/>
            </div>
            <div className='gallery-box'>
              <img src={img3}/>
            </div>
            <div className='gallery-box'>
              <img src={img4}/>
            </div>
            <div className='gallery-box'>
              <img src={img5}/>
            </div>
            <div className='gallery-box'>
              <img src={img6}/>
            </div>
            <div className='gallery-box'>
              <img src={img7}/>
            </div>
            <div className='gallery-box'>
              <img src={img8}/>
            </div>
            <div className='gallery-box'>
              <img src={img9}/>
            </div>
            <div className='gallery-box'>
              <img src={img10}/>
            </div>
          </div>
        </div>
      </section>

    </>
  )

}

export default Supportedasso;
